import {
  Button,
  Dialog,
  DialogContent,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from "@devhop/ui";
import { useEffect, useState } from "react";

export type PayoutBankFormValues = {
  bankName: string;
  bankAccount: string;
  accountName: string;
};

type PayoutRecipientBankEditDialogProps = {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  payeeName: string;
  hint?: string;
  initial: PayoutBankFormValues;
  readOnly?: boolean;
  onSave: (values: PayoutBankFormValues) => void;
};

const inputClass =
  "h-9 w-full rounded-md border border-input bg-background px-3 text-sm shadow-sm focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring disabled:cursor-not-allowed disabled:opacity-50";

export function PayoutRecipientBankEditDialog({
  open,
  onOpenChange,
  payeeName,
  hint,
  initial,
  readOnly,
  onSave,
}: PayoutRecipientBankEditDialogProps) {
  const [bankName, setBankName] = useState(initial.bankName);
  const [bankAccount, setBankAccount] = useState(initial.bankAccount);
  const [accountName, setAccountName] = useState(initial.accountName);

  useEffect(() => {
    if (!open) return;
    setBankName(initial.bankName);
    setBankAccount(initial.bankAccount);
    setAccountName(initial.accountName);
  }, [open, initial.bankName, initial.bankAccount, initial.accountName]);

  function handleSave() {
    onSave({ bankName, bankAccount, accountName });
    onOpenChange(false);
  }

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-md">
        <DialogHeader>
          <DialogTitle>ບັນຊີຮັບເງິນ — {payeeName}</DialogTitle>
        </DialogHeader>
        {hint ? (
          <p className="text-muted-foreground text-sm">{hint}</p>
        ) : null}
        <div className="grid gap-4 py-1">
          <label className="space-y-1.5">
            <span className="font-medium text-sm">ທະນາຄານ</span>
            <input
              className={inputClass}
              value={bankName}
              disabled={readOnly}
              onChange={(e) => setBankName(e.target.value)}
            />
          </label>
          <label className="space-y-1.5">
            <span className="font-medium text-sm">ເລກບັນຊີ</span>
            <input
              className={inputClass}
              value={bankAccount}
              disabled={readOnly}
              onChange={(e) => setBankAccount(e.target.value)}
            />
          </label>
          <label className="space-y-1.5">
            <span className="font-medium text-sm">ຊື່ບັນຊີ</span>
            <input
              className={inputClass}
              value={accountName}
              disabled={readOnly}
              onChange={(e) => setAccountName(e.target.value)}
            />
          </label>
        </div>
        <DialogFooter className="gap-2 sm:gap-0">
          <Button
            type="button"
            variant="outline"
            onClick={() => onOpenChange(false)}
          >
            {readOnly ? "ປິດ" : "ຍົກເລີກ"}
          </Button>
          {!readOnly ? (
            <Button type="button" onClick={handleSave}>
              ບັນທຶກ
            </Button>
          ) : null}
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
